import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------
const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const UserView = lazy(() => import('src/pages/user/userView'));
const UserNewCreateForm = lazy(() => import('src/pages/user/user-new-create-form'));
const ManagerEdition = lazy(() => import('src/components/manager/ManagerEdition'));
const UserNewEditForm = lazy(() => import('src/pages/user/user-new-edit-form'));
const TraineeProfileView = lazy( () =>
       import( 'src/pages/trainee/view/traineeProfile/traineeProfileView' )
);

// ----------------------------------------------------------------------

export const UserAdminRoutes = [
  {
    path: 'users',
    element: (
      <AuthGuard allowedRoles={['administrator']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <UserView />, index: true },
      { path: 'create', element: <UserNewCreateForm /> }, 
      { path: 'edition', element: <UserNewEditForm /> }, 
      { path: 'profile', element: <UserNewEditForm /> }, 
    ],
  },
];

export const UserTraineesRoutes = [
  {
    path: 'users/trainees/',
    element: (
      <AuthGuard allowedRoles={['trainee']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { path: 'profil', element: <TraineeProfileView /> }, 
    ],
  },
];


export const ManagerRoutes = [
  {
    path: 'manager',
    element: (
      <AuthGuard allowedRoles={['manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { path: 'profile', element: <ManagerEdition /> }, 
    ],
  },
];
